/**
 * Guide · Non-movers — the /reports/nonmover "Non-mover relocation review".
 * SKUs with no shipment in the review window that still hold a pick face;
 * relocating or de-listing them frees space without touching anything that
 * moves. The accepted set feeds the SKU Relocation capacity scenario.
 */

import { GuidePage } from "@/features/guide/guide-page";

export function GuideNonMoversPage() {
  return (
    <GuidePage
      eyebrow="Non-movers"
      title="What hasn't shipped, but still holds space."
      intro="Non-movers lists the SKUs that haven't shipped in the last review window yet still occupy a pick face. Relocating or de-listing them frees space without touching anything that actually moves. Accept the rows that hold up and the set flows straight into the SKU Relocation lever in Capacity scenarios, so a review turns into a capacity move."
      liveBullets={[
        {
          text: "Every non-mover with when it last shipped, its value, the recommended action, and the reasoning",
        },
        { text: "Accept or remove each row; the accepted set is the one you action" },
        { text: "Export all rows to CSV so Planning can work the full list, not a sample" },
        {
          text: "The accepted set feeds the SKU Relocation capacity scenario — a review that becomes a plan",
        },
      ]}
      walkthrough={[
        {
          step: "Scan the non-movers",
          body: "Each row shows how long a SKU has sat idle and what it's worth, so the easy calls surface first.",
        },
        {
          step: "Accept or remove",
          body: "Keep the rows worth relocating or de-listing; strike off anything you want to hold.",
        },
        {
          step: "Feed it into capacity",
          body: "Send the accepted set to the SKU Relocation lever in Capacity scenarios, or export it to CSV for Planning.",
        },
      ]}
      cta={{ to: "/reports/nonmover", label: "Open Non-movers" }}
    />
  );
}
